import winner from '../images/winner_fr.png';
//import bonusSpin from '../images/bonus-spin_fr.png'
import betterLuckNextTime from '../images/better-luck-next-time_fr.png';

const prizeFr = [
  {
    option: 'MEILLEUR CHANCE A LA PROCHAINE FOIS',
    image: { uri: betterLuckNextTime, sizeMultiplier: 1.52 },
    style: { backgroundColor: '#f6b01a' },
  },
  {
    option: 'GAGNANT!',
    image: { uri: winner, sizeMultiplier: 1.4 },
    style: { backgroundColor: '#0d7d7f' },
  },
  {
    option: 'GAGNANT!',
    image: { uri: winner, sizeMultiplier: 1.4 },
    style: { backgroundColor: '#3abb9d' },
  },
  {
    option: 'GAGNANT!',
    image: { uri: winner, sizeMultiplier: 1.4 },
    style: { backgroundColor: '#242c5b' },
  },
];

export { prizeFr };
